import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App";
import "./styles.css";
import { ErrorBoundary } from "./ErrorBoundary";
import { followSystemTheme } from "./theme";

const root = document.getElementById("root");
if (!root) throw new Error("Élément racine introuvable.");

// Les jetons sont posés avant le premier rendu : sinon la page s'afficherait un
// instant sans couleurs, puis sauterait.
followSystemTheme();

createRoot(root).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
);
